import React from 'react';
import створка1 from "../../images/Calculator/открывающаяся створка.png"
import створка2 from "../../images/Calculator/2 открывающиеся створки.png"
import run from "../../images/calculator-counter-right/run.png";
import "./main.css"
export default function Calculator() {

    return (
        <>
            <div className="calculator-header"></div>
            <div className="calculator">
                <div className="calculator-footer"></div>
                <div className="calculator-app">
                    <h2 className='title'>Калькулятор стоимости</h2>
                    <div className="btn-group">
                        <button className='okno'>Калькулятор окон</button>
                        <button>Калькулятор балконов</button>
                    </div>
                    <div className="calculator-counter">
                        <div className="calculator-counter-left">
                            <div className="tip-okno">
                                <p className='calculator-counter-title'>Тип окна</p>
                                <div className="btn-tip-okno-group">
                                    <button className='dvustvorchatoe'>Двустворчатое</button>
                                    <button>Трехстворчатое</button>
                                    <button>Балконный блок</button>
                                </div>
                            </div>
                            <div className="tip-otkiritive">
                                <p>Тип открывания <span>?</span></p>
                                <img src={створка1} alt="error" />
                                <img src={створка2} alt="error" />
                            </div>
                            <div className="tip-doma">
                                <p>Тип дома</p>
                                <div className="form-group-demo">
                                    <div className="form-group">
                                        <input type="checkbox" name="chexbox" id="chexbox1" />
                                        <label htmlFor="chexbox1">Панельный</label>
                                    </div>
                                    <div className="form-group">
                                        <input type="checkbox" name="chexbox" id="chexbox2" />
                                        <label htmlFor="chexbox2">Кирпичный</label>
                                    </div>
                                </div>
                            </div>
                            <div className="tip-profile">
                                <p>Тип профиля</p>
                                <div className="form-group-profile">
                                    <div className="form-group">
                                        <input type="checkbox" name="chexbox" id="chexbox3" />
                                        <label htmlFor="chexbox3">Эконом (Alpenprof)</label>
                                    </div>
                                    <div className="form-group">
                                        <input type="checkbox" name="chexbox" id="chexbox4" />
                                        <label htmlFor="chexbox4">Комфорт (КБЕ, Grain)</label>
                                    </div>
                                </div>
                                <div className="form-group-profile form-group-profile2">
                                    <div className="form-group">
                                        <input type="checkbox" name="chexbox" id="chexbox5" />
                                        <label htmlFor="chexbox5">Стандарт (GoodWin, EXPROF)</label>
                                    </div>
                                    <div className="form-group form2">
                                        <input type="checkbox" name="chexbox" id="chexbox6" />
                                        <label htmlFor="chexbox6">Премиум (Veka, Rehau)</label>
                                    </div>
                                </div>
                            </div>
                            <div className="dopolnatelno-laminatsiya">
                                <div className="dopolnitelno">
                                    <p>Дополнительно</p>
                                    <div className="form-group-profile">
                                        <div className="form-group">
                                            <input type="checkbox" name="chexbox" id="chexbox7" />
                                            <label htmlFor="chexbox7">Монтажные работы</label>
                                        </div>
                                        <div className="form-group">
                                            <input type="checkbox" name="chexbox" id="chexbox8" />
                                            <label htmlFor="chexbox8">Подоконник, водоотлив</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="laminatsiya">
                                    <p>Ламинация</p>
                                    <div className="form-group-profile">
                                        <div className="form-group">
                                            <input type="checkbox" name="chexbox" id="chexbox9" />
                                            <label htmlFor="chexbox9">Без ламинации</label>
                                        </div>
                                        <div className="form-group">
                                            <input type="checkbox" name="chexbox" id="chexbox10" />
                                            <label htmlFor="chexbox10">С ламинацией</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="calculator-counter-right">
                            <div className="razmer">
                                <p className='razmer-title'>Размеры</p>
                                <div className="shirina-visota">
                                    <div className="shirina">
                                        <label htmlFor="shirina">Ширина</label>
                                        <input type="text" value="1700" name="shirina" id="shirina" />
                                    </div>
                                    <div className="visota">
                                        <label htmlFor="visota">Высота</label>
                                        <input type="text" value="1700" name="visota" id="visota" />
                                    </div>
                                </div>
                            </div>
                            <div className="calculator-range">
                                <div class="range-group-height">
                                    <span>800</span>
                                    <input type="range" id='shirina-range' max="2500" value={1700} min="800" />
                                    <span>2500</span>
                                </div>
                                <div className="run">
                                    <img src={run} alt="error" />
                                </div>
                            </div>
                            <div class="range-group-width">
                                <input type="range" value={1700} id='visita-range' max="2500" min="800" />
                                <div className="range-group-width-number">
                                    <span>800</span>
                                    <span>2500</span>
                                </div>
                            </div>
                            <div className="calculator-beffore-summ">
                                <h3>Стоимость <span>?</span></h3>
                                <h3 id='shirina-sum'>24 742 руб </h3>
                            </div>
                            <div className="calculator-after-summ">
                                <p>Рассрочка за 739 р/мес.</p>
                                <p>
                                    <del>13 935 руб.</del>
                                </p>
                            </div>
                            <button className='get-a-quote'>Получить расчет</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}